import { render, staticRenderFns } from "./OfertaShowData.vue?vue&type=template&id=5fbc7c4e&scoped=true&"
import script from "./OfertaShowData.vue?vue&type=script&lang=js&"
export * from "./OfertaShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc7c4e",
  null
  
)

export default component.exports